import '@formatjs/intl-pluralrules/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-listformat/locale-data/en'
import '@formatjs/intl-displaynames/locale-data/en'
import '@formatjs/intl-numberformat/locale-data/en'
import '@formatjs/intl-datetimeformat/locale-data/en'
import coreEnTranslations from 'lib/core/resources/translations/en.json'
import enTranslations from './en.json'

/**
 * Available translations
 * @type array
 */
export const translations = [
  {
    code: 'en',
    title: 'English',
    keys: {
      ...coreEnTranslations,
      ...enTranslations
    },
    translationKey: 'locale.title.en'
  }
]
